import { EventEmitter } from 'events';
import dispatcher from '../dispatcher.js';
import { API, Auth } from 'aws-amplify';

class singleImageStore extends EventEmitter {
	constructor() {
		super();
		this.image = false;

		this.getImage = this.getImage.bind(this);
		this.receiveImage = this.receiveImage.bind(this);
	}

	getImage() {
		return this.image;
	}

	receiveImage(bucket, uuid) {
		return Auth.currentSession().then((userSession) => {
			let params = {
				headers: {
					Authentication: userSession.idToken.jwtToken
				}
			}
			return API.get('imageAPI', bucket + '/' + uuid, params);
		});
	}

	handleActions(action) {
		switch(action.type) {
			case 'getImage':
				this.receiveImage(action.bucket, action.uuid).then((response) => {
					if(response.status) {
						console.log(response);
						this.image = response.item
					}
					this.emit('change');
				});
			break;
			default:
			break;
		}
	}
}

const store = new singleImageStore();
dispatcher.register(store.handleActions.bind(store));

export default store;


// WEBPACK FOOTER //
// ./src/stores/single-image-store.js